import Reqwest from 'reqwest'
import Qwery from 'qwery'
import Cookies from 'js-cookie'
import Bean from 'bean'

import { debug } from './utilities'
import { emitter } from './features'

// let initialBehaviouralTrackingRequestSent
// let blacklistedValues = ['select size', 'choose an option...', 'выбрать размер', 'выберите размер', 'select your fit...', 'seleziona la dimensione']
let blacklistedValues = []

export function tracking (params) {
  return {
    init: startEasySizeTracking
  }
}

function stockUpdate (params) {
  let formData = {
    product_brand: params.product.brand,
    product_gender: params.product.gender,
    product_type: params.product.category,
    product_id: params.product.id,
    product_image_url: params.product.image_url,
    product_model: params.product.model,
    product_sku: params.product.sku,
    product_fit: params.product.fit,
    product_url: window.location.href,
    stock: JSON.stringify(params.product.stock),
    shop_id: params.shop.generated_shop_id
  }

  Reqwest({
    method: 'GET',
    url: `${params.easysize.widget_url}product_stock_update`,
    data: formData,
    error: (data) => { debug('[EasySize debug]: Error updating stock', data) },
    success: (data) => {}
  })
}

export function unsupportedProductTracking (params) {
  let formData = {
    is_product_supported: false,
    brand: params.product.brand,
    gender: params.product.gender,
    type: params.product.category.join(','),
    product_id: params.product.id,
    user_id: params.shop.user_id,
    user_type: params.easysize.user_type,
    uuid: params.easysize.uuid,
    img_url: params.product.image_url,
    model: params.product.model,
    product_title: params.product.title,
    sku: params.product.sku,
    fit: params.product.fit,
    language: params.shop.language,
    stock: JSON.stringify(params.product.stock),
    product_url: window.location.href,
    shop_id: params.shop.generated_shop_id,
    uq_key: params.easysize.user_id != -1 ? params.easysize.user_id : params.easysize.uuid, // eslint-disable-line
    width: window.innerWidth,
    height: window.innerHeight,
    demo_mode: params.easysize.demo_mode,
    session_id: params.easysize.session_id,
    tags: params.shop.tags
  }

  formData.tags = JSON.stringify(formData.tags)

  Reqwest({
    method: 'GET',
    url: `${params.easysize.tracking_url}analytics/init`,
    data: formData,
    error: (data) => { debug('[EasySize debug]: Error initiating tracking', data) },
    success: (data) => {
      if (data.hasOwnProperty('shop_sizeguide_selector')) {
        /* If sizeguide selector is present on our end, we track the clicks of that button */
        var sizeGuide = Qwery(data.shop_sizeguide_selector)[0]
        if (sizeGuide) {
          Bean.on(sizeGuide, 'click', () => {
            params.track(25)
          })
        }
      }

      Cookies.set('espageview', data.pageview_id, { expires: 28, secure: true, sameSite: 'strict' })
      params.device = data.device_info
      params.easysize.pageview_id = data.pageview_id
      params.easysize.tracking_started = true
    }
  })

  let track = (action, value = '') => {
    if (!action) { return }
    if (!params.easysize.tracking_started) {
      /* Try tracking again in one second, in case pageview is not yet set */
      setTimeout(() => {
        debug('[EasySize debug]: Repeating tracking as no pageview is yet set')
        track(action, value)
      }, 1000)
    } else {
      if (action === 19) {
        if (blacklistedValues.indexOf(value.toLowerCase()) !== -1) { return }
      }

      debug('[EasySize tracking]', params.easysize.pageview_id, action, value)
      var i = document.createElement('img')
      i.setAttribute('src', 'https://tracking.easysize.me/analytics/collect?_t=' + new Date().getTime() + '&a=' + action + '&v=' + value + '&pv=' + params.easysize.pageview_id)
      document.body.appendChild(i)
      document.body.removeChild(i)

      if ([2, 4, 5, 7, 21, 22, 23, 30].indexOf(action) !== -1) {
        window.postMessage(JSON.stringify({
          'easysize_tracking': true,
          'action': action,
          'value': value
        }), '*')
      }
    }
  }

  params.track = track
}

function startEasySizeTracking (params) {
  var formData = {
    brand: params.product.brand,
    gender: params.product.gender,
    type: params.product.category,
    product_id: params.product.id,
    user_id: params.shop.user_id,
    user_type: params.easysize.user_type,
    uuid: params.easysize.uuid,
    img_url: params.product.image_url,
    model: params.product.model,
    product_title: params.product.title,
    sku: params.product.sku,
    fit: params.product.fit,
    language: params.shop.language,
    stock: JSON.stringify(params.product.stock),
    product_url: window.location.href,
    shop_id: params.shop.generated_shop_id,
    uq_key: params.easysize.user_id != -1 ? params.easysize.user_id : params.easysize.uuid, // eslint-disable-line
    width: window.innerWidth,
    height: window.innerHeight,
    demo_mode: params.easysize.demo_mode,
    session_id: params.easysize.session_id,
    tags: params.shop.tags
  }

  if (Cookies.get('easysize_sizefilter_applied') && params.easysize.user_type === 'r') {
    debug('[EasySize debug]: product opened via size filter')
    formData.tags.push('size_filter')
  }

  if (Cookies.get('es_recommended_products')) {
    var esRecommendedProducts = JSON.parse(Cookies.get('es_recommended_products'))
    if (esRecommendedProducts.indexOf(params.product.id) !== -1) {
      esRecommendedProducts.splice(esRecommendedProducts.indexOf(params.product.id), 1)
      Cookies.remove('es_recommended_products', '/')
      formData.tags.push('recommended_product')
    }
  }

  formData.tags = JSON.stringify(formData.tags)

  Reqwest({
    method: 'GET',
    url: `${params.easysize.tracking_url}analytics/init`,
    data: formData,
    error: (data) => { 
      debug('[EasySize debug]: Error initiating tracking', data) 
      params.easysize.pageview_id = params.easysize.uuid
      params.easysize.tracking_started = true
    },
    success: (data) => {
      if (data.hasOwnProperty('shop_sizeguide_selector')) {
        /* If sizeguide selector is present on our end, we track the clicks of that button */
        var sizeGuide = Qwery(data.shop_sizeguide_selector)[0]
        if (sizeGuide) {
          Bean.on(sizeGuide, 'click', () => {
            params.track(25)
          })
        }
      }

      Cookies.set('espageview', data.pageview_id, { expires: 28, secure: true, sameSite: 'strict' })
      params.device = data.device_info
      params.easysize.pageview_id = data.pageview_id
      params.easysize.tracking_started = true
      Object.assign(params.features, data.features)

      /*
          Apply experiments needs a callback in order to load button html which needs to happen before loading easysize button
       */

      require.ensure('./features', (require) => {
        // eslint-disable-next-line no-unused-vars
        let removeSizeBot = require('./features').applyExperiments(data, params, () => {
          emitter.emit('easysize_tracking_initiated')
        })
      })
    }
  })

  let track = (action, value = '') => {
    if (!action) { return }
    if (!params.easysize.tracking_started) {
      /* Try tracking again in one second, in case pageview is not yet set */
      setTimeout(() => {
        debug('[EasySize debug]: Repeating tracking as no pageview is yet set')
        track(action, value)
      }, 1000)
    } else {
      if (action === 19) {
        if (blacklistedValues.indexOf(value.toLowerCase()) !== -1) { return }
      }

      debug('[EasySize tracking]', params.easysize.pageview_id, action, value)
      var i = document.createElement('img')
      i.setAttribute('src', 'https://tracking.easysize.me/analytics/collect?_t=' + new Date().getTime() + '&a=' + action + '&v=' + value + '&pv=' + params.easysize.pageview_id)

      document.body.appendChild(i)
      document.body.removeChild(i)

      if ([2, 4, 5, 7, 21, 22, 23, 30].indexOf(action) !== -1) {
        window.postMessage(JSON.stringify({
          'easysize_tracking': true,
          'action': action,
          'value': value
        }), '*')
      }
    }
  }

  params.track = track

  return { track: track }
}



// WEBPACK FOOTER //
// ./src/js/components/tracking.js